import * as React from "react";
import { connect, type ConnectedProps } from "react-redux";
import moment from "moment";
import { type ThunkDispatch } from "redux-thunk";
import { hideDialog } from "../../../../Actions/Dialogs/DialogActions";
import { safeDrop } from "../../../../Actions/SellScreen/SellScreenActions";
import Button from "../../../../Common/Buttons/Button";
import NoTranslate from "../../../../Common/NoTranslate";
import { type InjectedDataSourceProps, withDataSource } from "../../../../Data/DataStores/WithDataSource";
import { type RootState } from "../../../../Reducers/ShopfrontReducers";
import { currency } from "../../../../Utilities/Generic/Numbers";
import { printComponent } from "../../../../Utilities/UI/PrintHelper";
import MovementPrint from "../../../Register/ManageCash/MovementPrint";

function mapStateToProps(state: RootState): {
    register: null | string;
    outlet: null | string;
    user: string;
} {
    return {
        register: state.location.register === null ? null : state.location.register.name,
        outlet  : state.location.outlet === null ? null : state.location.outlet.name,
        user    : state.user.id === false ? "" : state.user.name,
    };
}

const connector = connect(mapStateToProps);

interface Props extends ConnectedProps<typeof connector>, InjectedDataSourceProps {
    dispatch: ThunkDispatch<any, any, any>;
    amount: number;
    method: string;
    callback?: () => void;
}

export class SafeDropConfirmDialog extends React.Component<Props> {
    protected handleCancelClick = (): void => {
        this.props.dispatch(hideDialog());
    };

    protected handlePerformClick = (): void => {
        this.props.dispatch(hideDialog());
        this.props.dispatch(safeDrop(this.props.amount, this.props.method, this.props.callback));

        printComponent(
            <MovementPrint
                amount={this.props.amount * -1}
                user={this.props.user}
                timestamp={moment().toISOString()}
                reason="Safe Drop"
                register={this.props.register as string}
                outlet={this.props.outlet as string}
            />
        );
    };

    public render(): React.ReactNode {
        return (
            <div className="safe-drop-confirm">
                <p>
                    Are you sure you would like to perform a safe drop of{" "}
                    <NoTranslate>
                        {currency(this.props.amount)}
                    </NoTranslate>?
                </p>
                <div className="buttons">
                    <Button classes={[ "button-cancel" ]} onClick={this.handleCancelClick}>Cancel</Button>
                    <Button classes={[ "button-add" ]} onClick={this.handlePerformClick}>Perform</Button>
                </div>
            </div>
        );
    }
}

export default connector(withDataSource(SafeDropConfirmDialog));
